import { ADD_SEGMENT_MODAL_OPEN_STATUS } from '../actionTypes';
import { actions } from '../reducer';

export default (isOpen) => (dispatch) => {
    dispatch(actions[ADD_SEGMENT_MODAL_OPEN_STATUS](isOpen));
};
